const LoyaltyActionTypes = {
  CHANGE_SCREEN: 'change_screen',
  OPEN_MODAL: 'open_modal',
};

const LoyaltyReducer = (state, action) => {
  switch (action.type) {
    case LoyaltyActionTypes.CHANGE_SCREEN:
      return {
        ...state,
        currentScreen: action.payload.screen,
        screenOptions: action.payload.options,
      };
    case LoyaltyActionTypes.OPEN_MODAL:
      return { ...state, [`${action.payload.screen}ModalOpened`]: action.payload.value };

    default:
      return state;
  }
};

const openScreen =
  (dispatch) =>
  (screen, options = {}) =>
    dispatch({ type: LoyaltyActionTypes.CHANGE_SCREEN, payload: { screen, options } });

const toggleModal = (dispatch) => (screen, value) =>
  dispatch({ type: LoyaltyActionTypes.OPEN_MODAL, payload: { screen, value } });

// eslint-disable-next-line import/prefer-default-export
export const loyalty = {
  LoyaltyReducer,
  actions: {
    toggleModal,
    openScreen,
  },
};
